import { useEffect } from 'react'
import { useSendWeeklyDigest } from '../../hooks/backend/dashboardPage'

const SESSION_KEY = 'weeklyDigestChecked'

// Sends the Monday digest the first time the Hub is opened each week. The
// backend skips it when this week's digest already went out, so this only
// asks once per browser session. Renders nothing.
export default function WeeklyDigestAutoSend() {
  const sendDigest = useSendWeeklyDigest()

  useEffect(() => {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return
      sessionStorage.setItem(SESSION_KEY, '1')
    } catch {
      // Storage unavailable: still check; the backend sends at most once a week.
    }
    void Promise.resolve(sendDigest.trigger({ onlyIfUnsent: true })).catch(() => undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
